import React, { useState, useEffect } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";
import DropDownInput from "../Input/dropDownInput/dropDownInput";

import { Button } from "react-bootstrap";

const EventSalaryFilter = ({
  showFilter = false,
  filterToggle,
  applyFilter,
  localstorageKey
}) => {
    const parseLocalStorage = () => {
        const data = JSON.parse(window.localStorage?.event_salary_filter || "{}");
        return {
          project_id: data.project_id || "",
          user_id: data.user_id || "",
          user_name: data.user_name || "",
          phone_number: data.phone_number || "",
          status:data.status ||'',
        };
    };
    
    const initialFilterInputs = parseLocalStorage();
    
  const [filterFieldsData, setFilterFieldsData] = useState({
    project_id: initialFilterInputs.project_id,
    user_id: initialFilterInputs.user_id,
    user_name: initialFilterInputs.user_name,
    phone_number: initialFilterInputs.phone_number,
    status: initialFilterInputs.status
  });

  useEffect(() => {
    const storedData = parseLocalStorage();
    setFilterFieldsData({
      project_id: storedData.project_id ? storedData.project_id : "",
      user_id: storedData.user_id ? storedData.user_id : "",
      user_name: storedData.user_name ? storedData.user_name : "",
      phone_number: storedData.phone_number? storedData.phone_number : "",
      status:storedData.status? storedData.status : "",
    });
  }, []);


  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter({
            project_id: filterFieldsData.project_id
              ? filterFieldsData.project_id
              : "",
            user_id: filterFieldsData.user_id ? filterFieldsData.user_id : "",
            user_name: filterFieldsData.user_name ? filterFieldsData.user_name : "",
            phone_number: filterFieldsData.phone_number? filterFieldsData.phone_number : "",
            status: filterFieldsData.status? filterFieldsData.status : "",
          });
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
      }}
    >
    <div className={showFilter ? "show-filter" : ""}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>MRF Filters</h4>
            <Button onClick={filterToggle} className="close">
              <i className="close"></i>
            </Button>
          </div>
          <div className="filter-body scrollbar-styling">
          <ConstantInput
                label={"Project Id"}
                value={window.localStorage?.event_salary_filter && window.localStorage?.event_salary_filter ? JSON.parse(window.localStorage?.event_salary_filter)['project_id'] : ""}
                type="text"
                handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, project_id: val });
                }}
            />
            <ConstantInput
                label={"User Id"}
                value={window.localStorage?.event_salary_filter && window.localStorage?.event_salary_filter ? JSON.parse(window.localStorage?.event_salary_filter)['user_id'] : ""}
                type="text"
                handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, user_id: val });
                }}
            />
            <ConstantInput
                label={"User Name"}
                value={window.localStorage?.event_salary_filter && window.localStorage?.event_salary_filter ? JSON.parse(window.localStorage?.event_salary_filter)['user_name'] : ""}
                type="text"
                handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, user_name: val });
                }}
            />
            <ConstantInput
                label={"Phone Number"}
                value={window.localStorage?.event_salary_filter && window.localStorage?.event_salary_filter ? JSON.parse(window.localStorage?.event_salary_filter)['phone_number'] : ""}
                type="number"
                handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, phone_number: val });
                }}
            />
            <DropDownInput
                label="Status"
                data={[
                {
                    id: "PENDING",
                    name: "PENDING",
                },
                {
                    id: "SYSTEM_CALCULATED",
                    name: "SYSTEM_CALCULATED",
                },
                {
                    id: "OPS_CALCULATED",
                    name: "OPS_CALCULATED",
                },
                {
                    id: "OPS_FREEZED",
                    name: "OPS_FREEZED",
                },
                {
                    id: "OPS_APPROVED",
                    name: "OPS_APPROVED",
                },
                {
                    id: "OPS_REJECTED",
                    name: "OPS_REJECTED",
                },
                {
                    id: "FINANCE_MODIFICATION_REQUESTED",
                    name: "FINANCE_MODIFICATION_REQUESTED",
                }
                ]}
                getIdValue={(val) => {
                setFilterFieldsData({ ...filterFieldsData, status: val?.id });
                }}
                value={window.localStorage?.event_salary_filter && window.localStorage?.event_salary_filter ? JSON.parse(window.localStorage?.event_salary_filter)['status'] : ""}
            />
            <div className="btn-wrapper">
              <button
                disabled={false}
                type="submit"
                className="btn btn-primary"
              >
                {localization.applyFilter}
                <img src={Images?.ArrowRight} alt="" />
              </button>
              <br />
              <br />
              <button
                onClick={() => {
                  localStorage.setItem(
                    "event_salary_filter",
                    JSON.stringify(initialFilterInputs)
                  );
                  applyFilter({
                    project_id: "",
                    user_id: "",
                    user_name: "",
                    phone_number: "",
                    status:""
                });
                }}
                type="button"
                className="btn btn-primary"
              >
                {localization.removeFilter}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </form>
  );
};

export default EventSalaryFilter;
